import { useStores } from '@src/components/store';
import React, { useMemo } from 'react';
import { Direction } from '@src/utils/enums';
import UsageIcon from '@svg/usage_24.svg?react';
import ArrowRightIcon from '@svg/outgoing-direction.svg?react';
import { Link } from 'react-router-dom';

export const AiAppsUsageBanner = () => {
    const { customerStore } = useStores();

    const path = useMemo(() => `/${customerStore.customerId}/${customerStore.serviceId}/insights/reports/App Traffic`,
        [customerStore.customerId, customerStore.serviceId]);

    return (
        <div className="ai-apps-usage-banner">
            <div className="ai-apps-usage-banner__left">
                <UsageIcon />
                <span className="ai-apps-usage-banner__title">AI apps usage</span>
                <span className="ai-apps-usage-banner__subtitle">View top AI apps used in your network</span>
            </div>
            <Link className="ai-apps-usage-banner__link" to={path} state={{direction: Direction.Outbound, aiDefense: true}}>
                View report
                <ArrowRightIcon />
            </Link>
        </div>
    );
};